var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"spentOnlyPane"}},[_c('gl-sprintf',{attrs:{"message":_vm.$options.timeSpent},scopedSlots:_vm._u([{key:"spent",fn:function({ content }){return [_c('span',{staticClass:"gl-font-bold"},[_vm._v(_vm._s(content))]),_vm._v(_vm._s(_vm.timeSpentHumanReadable)+"\n    ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }